import Vue from '@triotech/vue-core/src/vendor/vue';
import I18n from '@triotech/vue-core/src/lib/plugins/i18n';

// Some helper functions
const Helper = new Vue({
  i18n: I18n,
  methods: {
    // Add right image path
    imageUrl(val, thumb = false) {
      const uploadUri = this.$ajax.getUploadsUri(val);
      if (thumb) {
        return uploadUri.replace('uploads', 'media/cache/resolve/mosaic');
      }
      return uploadUri;
    },
    // Get right API uri
    getUri(path) {
      if (this.$root.canManage()) {
        return `api/memorial/${this._.get(this.user(), 'memorial.id')}/${path}/`;
      }

      return `api/public/memorial/${this._.get(this.get(), 'memorial.id')}/${path}/`;
    },
    // Determined if the user can manage the publications
    canManage() {
      return !!this.oauth() && !!this.get().memorial && (this.get().memorial.id === (this.user().memorial && this.user().memorial.id));
    },
    // Determined if the memorial is the demo memorial
    isDemo() {
      return !!this.get().memorial && this.get().memorial.demo;
    },
    demoFallbackTranslation(entity, key) {
      if (this.isDemo() && entity[key]) {
        return this.$t(entity[key].replace(/<[^>]+>/g, ''));
      }
      return entity[key] || '-';
    },
  },
});

Vue.set(Vue.prototype, '$helper', Helper);

export default Helper;



// WEBPACK FOOTER //
// ./src/plugins/helper.js